import { render, staticRenderFns } from "./feature-position-management.vue?vue&type=template&id=9ece5434&scoped=true"
import script from "./feature-position-management.vue?vue&type=script&lang=js"
export * from "./feature-position-management.vue?vue&type=script&lang=js"
import style0 from "./feature-position-management.vue?vue&type=style&index=0&id=9ece5434&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ece5434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4173828048/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ece5434')) {
      api.createRecord('9ece5434', component.options)
    } else {
      api.reload('9ece5434', component.options)
    }
    module.hot.accept("./feature-position-management.vue?vue&type=template&id=9ece5434&scoped=true", function () {
      api.rerender('9ece5434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feature-position-management.vue"
export default component.exports